import { chat } from "../endpoints/chat.endpoints";
import $axios from "../http/accessor";

const NotificationService = {
  getNotifications: () => $axios.get(chat.notifications),
  getNotificationCount: () => $axios.get(chat.notifications_count),
  markNotificationRead: (notification_id: number) =>
    $axios.post(chat.notifications_read, null, {
      params: { notification_id },
    }),
  markAllNotificationsRead: () => $axios.post(chat.notifications_read_all),
};

export default NotificationService;
